import { render, staticRenderFns } from "./AuxiliaryMenu.vue?vue&type=template&id=1457676c&scoped=true"
import script from "./AuxiliaryMenu.vue?vue&type=script&lang=js"
export * from "./AuxiliaryMenu.vue?vue&type=script&lang=js"
import style0 from "./AuxiliaryMenu.vue?vue&type=style&index=0&id=1457676c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457676c",
  null
  
)

export default component.exports